export const dateToString = (date: Date): string => {
  const month = (date.getMonth() + 1).toString();
  const monthDay = date.getDate().toString();
  return `${date.getFullYear()}-${month.length == 1 ? "0"+month : month}-${monthDay.length == 1 ? "0"+monthDay : monthDay}`;
}

export const dateToFormattedString = (date: Date, showWeekDay = false): string => {
  const weekday: Partial<Intl.DateTimeFormatOptions> = showWeekDay ? {
    weekday: 'long',
  } : {};

  return date.toLocaleDateString('en-US', {
    ...weekday,
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export const formatDateToUS = (date: Date): string => {
  let day = date.getDate().toString();
  let month = (date.getMonth() + 1).toString();
  let year = date.getFullYear();

  return `${month.length == 1 ? "0"+month : month}/${day.length == 1 ? "0"+day : day}/${year}`;
}

export const makeDateFromString = (dateString:string): Date => {
  const dateSplitted = dateString.split('-');
  if(dateSplitted.length !== 3) {
    return new Date;
  }
  return new Date( parseInt(dateSplitted[0]), parseInt(dateSplitted[1])-1, parseInt(dateSplitted[2]) );
}
